import { CloseIcon } from "@chakra-ui/icons";
import { Button, Flex, Text } from "@chakra-ui/react";
import { useDropzone } from "react-dropzone";
import ExcelIcon from "../../assets/images/product-list/excel-icon.png";
import downloadFile from "../helpers/downloadFile";

const UploadIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="32"
    height="32"
    viewBox="0 0 32 32"
    fill="none"
  >
    <path
      d="M15.9999 29.3334H6.66659C5.93021 29.3334 5.33325 28.7364 5.33325 28.0001V4.00008C5.33325 3.2637 5.93021 2.66675 6.66659 2.66675H25.3333C26.0697 2.66675 26.6666 3.2637 26.6666 4.00008V16.0001"
      stroke="#2A3D4A"
      stroke-width="2.66667"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M23.6667 29.3334V20.6667"
      stroke="#2A3D4A"
      stroke-width="2.66667"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M20.6667 23L21.6667 22L23.6667 20L25.6667 22L26.6667 23"
      stroke="#2A3D4A"
      stroke-width="2.66667"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M10.6667 10.6667H21.3334"
      stroke="#2A3D4A"
      stroke-width="2.66667"
      stroke-linecap="round"
    />
    <path
      d="M10.6667 16H16.0001"
      stroke="#2A3D4A"
      stroke-width="2.66667"
      stroke-linecap="round"
    />
  </svg>
);

const UploadFile = ({ files, handleSelectFile, isDisabled, maxFiles }) => {
  const { getRootProps, getInputProps } = useDropzone({
    accept: {
      "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet": [
        ".xlsx",
      ],
      "application/vnd.ms-excel": [".xls"],
    },
    disabled: isDisabled,
    maxFiles,
    onDrop: handleSelectFile,
  });

  return (
    <Flex
      {...getRootProps({
        background: "#F8F9FD",
        border: "1px solid #D6D6D6",
        borderRadius: "4px",
        p: "32px 20px",
        direction: "column",
        alignItems: "center",
        gap: "12px",
        cursor: isDisabled ? "not-allowed" : "pointer",
        minH: "205px",
      })}
    >
      {files.length === 0 ? (
        <>
          <input {...getInputProps()} />
          <Flex margin="auto" justify="center">
            <UploadIcon />
          </Flex>
          <Text color="#2A3D4A" fontSize="14px" mb="16px">
            Klik atau Drag file ke area ini
          </Text>
          <Button
            variant="outline"
            borderWidth="2px"
            borderColor="#3378D6"
            color="#3378D6"
            fontSize="14px"
            px="28px"
          >
            Select File
          </Button>
        </>
      ) : (
        <>
          <img alt="" src={ExcelIcon} style={{ height: 32 }} />
          {files.map((file, index) => (
            <Flex
              justifyContent="space-between"
              alignItems="center"
              w="full"
              borderWidth="1px"
              borderColor={isDisabled ? "#ADADAD" : "#3378D6"}
              color={isDisabled ? "#ADADAD" : "#3378D6"}
              borderRadius="4px"
              onClick={(e) => {
                e.stopPropagation();
                downloadFile(file);
              }}
            >
              <Text
                color="inherit"
                fontSize="14px"
                fontStyle="italic"
                textDecoration="underline"
                p="8px 16px"
              >
                {file.name}
              </Text>

              <Button
                colorScheme="red"
                color={isDisabled ? "#ADADAD" : "#E6001C"}
                fontSize="12px"
                variant="ghost"
                onClick={(e) => {
                  e.stopPropagation();
                  handleSelectFile(files.filter((_, i) => i != index));
                }}
                disabled={isDisabled}
              >
                <CloseIcon />
              </Button>
            </Flex>
          ))}
          <Text color="#2A3D4A" fontSize="14px" mt="16px">
            Proses berhasil. Silakan upload file
          </Text>
        </>
      )}
    </Flex>
  );
};

export default UploadFile;
